import i18n from "@/i18n";

export const DEBOUNCE_SEARCH_MS = 500;
export const OPPOSITE_SORT = {
    asc: "desc",
    desc: "asc",
};

export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_SIZE_OPTIONS = [10, 30, 50, 100];

export const REGISTRATION_DOCUMENTS = [
    i18n.t('message.doc.copyOfIDCard'),
    i18n.t('message.doc.copyOfHomeRegistration'),
    i18n.t('message.doc.copyOfBirthCertificate'),
    i18n.t('message.doc.CopyOfNameChange'),
    i18n.t('message.doc.CopyOfLegitimationOfChild'),
    i18n.t('message.doc.medicalCertificate'),
    i18n.t('message.doc.CopyOfTranscript'),
    i18n.t('message.doc.portfolio')
];

export const REGISTRATION_DOCUMENTS_MAPPING = {
    hasDocumentNationalId: 'message.doc.copyOfIDCard',
    hasDocumentHouseRegistration: 'message.doc.copyOfHomeRegistration',
    hasDocumentProofOfBirth: 'message.doc.copyOfBirthCertificate',
    hasDocumentProofOfNameChanged: 'message.doc.copyOfNameChange',
    hasDocumentProofOfAdopted: 'message.doc.copyOfLegitimationOfChild',
    hasDocumentMedicalCertificate: 'message.doc.medicalCertificate',
    hasDocumentTranscript: 'message.doc.copyOfTranscript',
    hasDocumentPortfolio: 'message.doc.portfolio'
}

export const REGISTRATION_DOCUMENTS_MAPPING_TH = {
    hasDocumentNationalId: 'สำเนาบัตรประชาชนนักเรียน',
    hasDocumentHouseRegistration: 'สำเนาทะเบียนบ้านนักเรียน',
    hasDocumentProofOfBirth: 'สำเนาสูติบัตร',
    hasDocumentProofOfNameChanged: 'สำเนาหลักฐานการเปลี่ยนชื่อ - สกุล',
    hasDocumentProofOfAdopted: 'สำเนาใบจดทะเบียนเป็นบุตรบุญธรรม',
    hasDocumentMedicalCertificate: 'ใบรับรองแพทย์',
    hasDocumentTranscript: 'สำเนาระเบียนแสดงผลการเรียน (ปพ.1) ด้านหน้าและด้านหลัง',
    hasDocumentPortfolio: 'แฟ้มสะสมผลงาน (Portfolio)' ,
}

export const FORM_STATUS_OPTION = [{
        value: "",
        label_th: "สถานะทั้งหมด",
        label_en: "All status"
    },
    {
        value: "DRAFT",
        label_th: "ฉบับร่าง",
        label_en: "Draft"
    },
    {
        value: "WAIT",
        label_th: "รอเปิดใช้งาน",
        label_en: "Waiting for activation"
    },
    {
        value: "ACTIVE",
        label_th: "เปิดใช้งาน",
        label_en: "Active"
    },
    {
        value: "DEACTIVE",
        label_th: "ปิดใช้งาน",
        label_en: "Inactive"
    },
];

export const FORM_STATUS_CALENDAR_OPTION = [{
        value: "",
        label_th: "สถานะทั้งหมด",
        label_en: "All status"
    },
    {
        value: "ACTIVE",
        label_th: "เปิดใช้งาน",
        label_en: "Active"
    },
    {
        value: "WAIT_TRANSFER",
        label_th: "รอโอนข้อมูล",
        label_en: "Waiting for transfer"
    },
    {
        value: "ON_PROCESS_TRANSFER",
        label_th: "ดำเนินการโอนข้อมูล",
        label_en: "Transfer"
    },
    {
        value: "SUCCESSFUL_TRANSFER",
        label_th: "โอนข้อมูลสำเร็จ",
        label_en: "Transferred",
    },
];

export const FORM_STATUS_TH = {
    DRAFT: "ฉบับร่าง",
    WAIT: "รอเปิดใช้งาน",
    ACTIVE: "เปิดใช้งาน",
    DEACTIVE: "ปิดใช้งาน",
    WAIT_TRANSFER: "รอโอนข้อมูล",
    ON_PROCESS_TRANSFER: "ดำเนินการโอนข้อมูล",
    SUCCESSFUL_TRANSFER: "โอนข้อมูลสำเร็จ",
};

export const FORM_STATUS_MAPPING = {
    DRAFT: {
        text_th: "ฉบับร่าง",
        text_en: "Draft",
    },
    WAIT: {
        text_th: "รอเปิดใช้งาน",
        text_en: "Waiting for activation",
    },
    ACTIVE: {
        text_th: "เปิดใช้งาน",
        text_en: "Active",
    },
    DEACTIVE: {
        text_th: "ปิดใช้งาน",
        text_en: "Inactive",
    },
    WAIT_TRANSFER: {
        text_th: "ปิดใช้งาน",
        text_en: "Inactive",
    },
    ON_PROCESS_TRANSFER: {
        text_th: "ปิดใช้งาน",
        text_en: "Inactive",
    },
    SUCCESSFUL_TRANSFER: {
        text_th: "ปิดใช้งาน",
        text_en: "Inactive",
    },
};

export const SALARY_RANGE = [
    // เดี๋ยวลบ ยังไม่ได้แก้
    {
        name_en: "Less than 5,000 Bah",
        name_th: "น้อยกว่า 5,000 บาท",
        value: "5000",
    },
    {
        name_en: "5,001 - 15,000 Baht",
        name_th: "5,001 - 15,000 บาท",
        value: "15000",
    },
    {
        name_en: "15,001 - 30,000 Baht",
        name_th: "15,001 - 30,000 บาท",
        value: "30000",
    },
    {
        name_en: "30,001 - 50,000 Baht",
        name_th: "30,001 - 50,000 บาท",
        value: "50000",
    },
    {
        name_en: "More than 50,000 Baht",
        name_th: "มากกว่า 50,000 บาท",
        value: "100000",
    },
];

export const STUDENT_ALLOWANCE = [{
        value: "FATHER_MOTHER",
        text_th: "พ่อแม่",
        text_en: "Father/Mother",
    },
    {
        value: "PARENTS",
        text_th: "ผู้ปกครอง",
        text_en: "Parents",
    },
    {
        value: "SELF_EARN",
        text_th: "หาเงินเอง",
        text_en: "By yourself",
    },
];

export const FAMILY_STATUS = [{
        value: "TOGETHER",
        text: 'message.form.parentData.together',
    },
    // {
    //     value: "DIVORCED",
    //     text: 'message.form.parentData.divorce',
    // },
    {
        value: "SEPARATED",
        text: 'message.form.parentData.separated',
    },
    {
        value: "FATHER_DECEASED",
        text: 'message.form.parentData.father_deceased',
    },
        {
        value: "MOTHER_DECEASED",
        text: 'message.form.parentData.mother_deceased',
    },
        {
        value: "DECEASED",
        text: 'message.form.parentData.deceased',
    },
  ];

export const TRANSPORTATION_TYPE = [{
        value: "WALK_BICYCLE",
        text: 'message.form.addressData.walkBike',
    },
    {
        value: "MOTOR_CYCLE",
        text: 'message.form.addressData.schoolBus',
    },
    {
        value: "PRIVATE_CAR",
        text: 'message.form.addressData.Motorcycle',
    },
    {
        value: "SHUTTLE_BUS",
        text: 'message.form.addressData.personalCar',
    },
    {
        value: "PUBLIC_TRANSPORT",
        text: 'message.form.addressData.publicTransport',
    },
];

export const ACCOMMODATION_TYPE = [{
        value: "OWN_HOUSE",
        text: 'message.form.addressData.ownHome',
    },
    {
        value: "RENTAL_HOUSE",
        text: 'message.form.addressData.hiredHouse',
    },
    {
        value: "RELATIVE_HOUSE",
        text: 'message.form.addressData.livingWithOther',
    },
];

export const RegistrationStatusEnum = Object.freeze({
    REGISTER: "REGISTER", //ลงทะเบียน
    PENDING_PAYMENT: "PENDING_PAYMENT", //รอการชำระเงิน
    SUCCESSFUL_PAYMENT: "SUCCESSFUL_PAYMENT", //ชำระเงินแล้ว
    EXAM_AUTHORIZE: "EXAM_AUTHORIZE", //มีสิทธิ์สอบ
    EXAM_AUTHORIZE_BY_SYSTEM: "EXAM_AUTHORIZE_BY_SYSTEM", //มีสิทธิ์สอบ
    EXAM_UNAUTHORIZE: "EXAM_UNAUTHORIZE", //ไม่มีสิทธิ์สอบ
    NOT_QUALIFY: "NOT_QUALIFY", //ไม่ผ่านเกณฑ์
    PENDING_CONFIRMATION: "PENDING_CONFIRMATION", //รอการยืนยันสิทธิ์
    REJECTION: "REJECTION", //สละสิทธิ์
    SUCCESSFUL_CONFIRMATION: "SUCCESSFUL_CONFIRMATION", //ยืนยันสิทธิ์
    SUCCESSFUL_CONFIRMATION_DETAIL: "SUCCESSFUL_CONFIRMATION_DETAIL", //ยืนยันสิทธิ์
    SUCCESSFUL_ENROLLMENT: "SUCCESSFUL_ENROLLMENT", //มอบตัวสำเร็จ
})

export const ResultTypeEnum = Object.freeze({
    PASS: "PASS",
    RESERVED: "RESERVED",
    FAILED: "FAILED",
});

export const AdmissionStatusEnum = [{
        text_th: "สถานะทั้งหมด",
        text_en: "All Status",
        value: null
    },
    {
        text_th: "สำเร็จ",
        text_en: "SUCCESS",
        value: "SUCCESS"
    },
    {
        text_th: "รอดำเนินการ",
        text_en: "WAIT",
        value: "WAIT"
    }
]


export const REGISTRATION_STATUS_OPTION = [{
        value: "",
        label_th: "สถานะทั้งหมด",
        label_en: "All status",
    },
    {
        value: "REGISTER",
        label_th: "ลงทะเบียน",
        label_en: "Register",
    },
    {
        value: "PENDING_PAYMENT",
        label_th: "รอการชำระเงิน",
        label_en: "Pending payment",
    },
    {
        value: "SUCCESSFUL_PAYMENT",
        label_th: "ชำระเงินสำเร็จ",
        label_en: "Payment complete",
    },
    {
        value: "EXAM_AUTHORIZE",
        label_th: "มีสิทธิ์สอบ",
        label_en: "Qualified",
    },
    {
        value: "EXAM_UNAUTHORIZE",
        label_th: "ไม่มีสิทธิ์สอบ",
        label_en: "Not qualified",
    },
    {
        value: "PENDING_CONFIRMATION",
        label_th: "รอการยืนยันสิทธิ์",
        label_en: "Waiting for confirmation",
    },
    {
        value: "SUCCESSFUL_CONFIRMATION_DETAIL",
        label_th: "ยืนยันสิทธิ์",
        label_en: "Confirmed",
    },
    {
        value: "REJECTION",
        label_th: "สละสิทธิ์",
        label_en: "Waiver",
    },
    {
        value: "SUCCESSFUL_ENROLLMENT",
        label_th: "มอบตัวสำเร็จ",
        label_en: "Initiation complete",
    },
    {
        value: "NOT_QUALIFY",
        label_th: "ไม่ผ่านเกณฑ์",
        label_en: "Not passed",
    },
];

export const RESULT_TYPE_OPTION = [{
        value: "",
        label_th: "ผลคัดเลือกทั้งหมด",
        label_en: "All result",
    },
    {
        value: "PASS,RESERVED",
        label_th: "ผ่านเกณฑ์",
        label_en: "Passed",
    },
    {
        value: "FAILED",
        label_th: "ไม่ผ่านเกณฑ์",
        label_en: "Not passed",
    }
];

export const STUDENT_TYPE_MAPPING = {
    "PASS": {
        text_th: "ผ่านเกณฑ์",
        text_en: "Pass"
    },
    "RESERVED": {
        text_th: "ผ่านเกณฑ์",
        text_en: "Pass"
    },
    "FAILED": {
        text_th: "ไม่ผ่านเกณฑ์",
        text_en: "Failed"
    },
}

export const STUDENT_RESULT_TYPE_MAPPING = {
    "PASS": {
        text_th: "ตัวจริง",
        text_en: "Pass"
    },
    "RESERVED": {
        text_th: "ตัวสำรอง",
        text_en: "Reserved"
    },
    "FAILED": {
        text_th: "-",
        text_en: "-"
    },
}

export const STUDENT_REGISTRATION_STATUS_MAPPING = {
    "REGISTER": {
        text_th: "ลงทะเบียน",
        text_en: "Register"
    },
    "PENDING_PAYMENT": {
        text_th: "รอการชำระเงิน",
        text_en: "Pending Payment"
    },
    "SUCCESSFUL_PAYMENT": {
        text_th: "ชำระเงินสำเร็จ",
        text_en: "Successful Payment"
    },
    "EXAM_AUTHORIZE": {
        text_th: "มีสิทธิ์สอบ",
        text_en: "Exam Authorize"
    },
    "EXAM_AUTHORIZE_BY_SYSTEM": {
        text_th: "มีสิทธิ์สอบ",
        text_en: "Exam Authorize"
    },
    "EXAM_UNAUTHORIZE": {
        text_th: "ไม่มีสิทธิ์สอบ",
        text_en: "Exam Unauthorize"
    },
    "PENDING_CONFIRMATION": {
        text_th: "รอการยืนยันสิทธิ์",
        text_en: "Pending Confirmation"
    },
    "SUCCESSFUL_CONFIRMATION": {
        text_th: "ยืนยันสิทธิ์",
        text_en: "Confirmation"
    },
    "SUCCESSFUL_CONFIRMATION_DETAIL": {
        text_th: "ยืนยันสิทธิ์",
        text_en: "Confirmation"
    },
    "REJECTION": {
        text_th: "สละสิทธิ์",
        text_en: "Rejection"
    },
    "SUCCESSFUL_ENROLLMENT": {
        text_th: "มอบตัวสำเร็จ",
        text_en: "Successful Enrollment"
    },
    "NOT_QUALIFY": {
        text_th: "ไม่ผ่านเกณฑ์",
        text_en: "Not Qualify"
    },
}

export const GRADE_LEVEL_TYPE_OPTIONS = [{
        value: 5,
        label_th: "ป.5",
        label_en: "ป.5",
    },
    {
        value: 7,
        label_th: "ม.1",
        label_en: "ม.1",
    }
];

export const YES_NO_STATUS = [{
        value: false,
        text: 'message.form.parentData.siblings_study_no',
    },
    {
        value: true,
        text: 'message.form.parentData.siblings_study_yes',
    }
];

export const REGISTRATION_DOCUMENTS_DEFAULT = [
    { name: 'message.doc.extraDoc1', value: true },
    { name: 'message.doc.extraDoc2', value: true },
    { name: 'message.doc.extraDoc3', value: true },
    { name: 'message.doc.extraDoc4', value: true },
    { name: 'message.doc.extraDoc5', value: true },
    { name: 'message.doc.extraDoc6', value: true },
]
